import { Box, Heading, Image, Text, VStack } from "@chakra-ui/react";

import antes from "../assets/images/evolucion_operacion_fiscal/Antes.webp";
import durante from "../assets/images/evolucion_operacion_fiscal/Durante.webp";
import despues from "../assets/images/evolucion_operacion_fiscal/Despues.webp";

const cards = [
  {
    image: antes,
    title: "Antes",
    description:
      "Dificultad para identificar inconsistencias. Cuando aparecen, ya llegó un requerimiento del SAT o ya comenzó una auditoría",
  },
  {
    image: durante,
    title: "Durante",
    description:
      "Los agentes revisan cada CFDI en tiempo real, te alertan solo cuando algo requiere tu atención y mantienen tu información trazable en todo momento. Tú te enfocas en decidir; ellos en que todo cuadre.",
  },
  {
    image: despues,
    title: "Después",
    description:
      "Tu operación fiscal ordenada, visible y bajo control. Sin la presión de no saber si algo está mal, y con la certeza de poder responder ante cualquier revisión.",
  },
];

export const EvolucionFiscal = () => {
  return (
    <Box py={{ base: 10, md: 16 }} px={{ base: 4, md: "30px", lg: "60px" }} bg="#F7F9FF">
      <VStack spacing={14}>
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "38px" }}
          fontWeight="700"
          color="#0A33FF"
          textAlign="center"
          data-aos="fade-up"
        >
          La evolución de la operación fiscal
        </Heading>

        <Box
          display="grid"
          gridTemplateColumns={{ base: "1fr", lg: "1fr 1fr", xl: "1fr 1fr 1fr" }}
          gap="24px"
          w="100%"
          data-aos="fade-up"
          data-aos-anchor-placement="top-center"
        >
          {cards.map((card, index) => (
            <VStack
              key={card.title}
              align="start"
              spacing={4}
              bg="white"
              borderRadius="24px"
              p={6}
              boxShadow="0px 4px 16px rgba(14, 46, 251, 0.3)"
              transition="transform 0.25s ease"
              _hover={{ transform: "scale(1.05)" }}
              gridColumn={{ lg: index === 2 ? "1 / -1" : "auto", xl: "auto" }}
            >
              <Image
                src={card.image}
                alt={card.title}
                htmlWidth={900}
                htmlHeight={600}
                w="100%"
                h="300px"
                objectFit="cover"
                objectPosition={index === 2 ? "top" : "center"}
                borderRadius="16px"
                loading="lazy"
              />
              <Text fontSize={{ base: "xl", md: "2xl", lg: "32px" }} fontWeight="700" color="#0A33FF" lineHeight="1.2">
                {card.title}
              </Text>
              <Text fontSize={{ base: "16px", md: "18px", lg: "23px" }} fontWeight="400" color="#0A33FF" lineHeight="1.4">
                {card.description}
              </Text>
            </VStack>
          ))}
        </Box>
      </VStack>
    </Box>
  );
};
